<template>

    <div class="info_container bottom" v-if="consultancy.detail" >
        <div class="container_design ">
            <div class="info_title">General Info</div>
            <div class="info_content ">
                <div class="info_content_data_container">
                    <div class="info_container_title">Established At</div>
                    <div class="info_container_data">{{consultancy.detail.established}}</div>
                </div>
                <div class="info_content_data_container">
                    <div class="info_container_title">Location</div>
                    <div class="info_container_data">{{consultancy.detail.location}}</div>
                </div>
                <div class="info_content_data_container">
                    <div class="info_container_title">Phone Number</div>
                    <div class="info_container_data">{{consultancy.detail.phone}}</div>
                </div>
            </div>  
        </div>
        <div class="container_design ">
            <div class="info_title">Courses</div>
            <div class="info_content ">
            <ul class="info_list">
                <li v-for="(course,index) in consultancy.detail.courses" :key="index" >{{course}}</li>
            </ul>
            </div>
        </div>
        <div class="container_design">
           <div class="info_title">Countries</div>
            <div class="info_content ">
            <ul class="info_list">
                <li v-for="(country, index) in consultancy.detail.countries" :key="index">{{country}}</li>
            </ul>  
            </div>
        </div>

    </div>
</template>
<script>
import {mapGetters} from 'vuex';
export default {
    computed: {
        ...mapGetters(['consultancy'])
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/ConsultancyProfile/_about.vue